module.exports = __webpack_public_path__ + "static/media/suseso.ee2a7114.jpg";